import { ref as v, computed as r, toValue as q } from "vue";
import { isEmpty as d } from "../../../utils/isEmpty.js";
import { isError as O } from "../Form.helpers.js";
const R = (a, l) => l?.value ? a in l.value && !!l.value[a] : !1, j = (a, l) => l ? a in l.value && l.value[a] : !1;
function I(a, l, f) {
  const i = v(), t = v(), u = v(!1), o = r(() => t.value && !d(t.value) && Object.values(t.value).some((e) => !d(e))), V = r(() => u.value && o.value), E = r(() => u.value ? t.value ?? {} : {}), h = r(() => !o.value);
  function b() {
    u.value = !0;
  }
  function p() {
    u.value = !1, i.value = {}, t.value = {};
  }
  function c(e) {
    i.value ??= {};
    const n = q(f);
    i.value[e] = n(
      e,
      a.value[e],
      a.value
    );
    const s = i.value[e];
    t.value ??= {}, O(s) ? t.value[e] = s : delete t.value[e];
  }
  const m = r(() => {
    if (!a.value) return [];
    function e(n) {
      return j(n, l) || R(n, t);
    }
    return Object.keys(a.value).filter(e);
  });
  function y() {
    m.value.forEach(c);
  }
  function F() {
    Object.keys(a.value).forEach(
      (e) => c(e)
    );
  }
  return {
    validateOnlyDirtyAndInErrorFields: y,
    validateAllFields: F,
    errors: t,
    hasError: o,
    visibleErrors: E,
    hasVisibleError: V,
    shouldShowErrors: u,
    isValid: h,
    makeErrorsVisible: b,
    resetValidation: p
  };
}
export {
  I as useValidation
};
